export default ({
    onClick,
    onCancel,
    button
}) => {
    return (
        <div className="verification-page">
            <div className="verification-alert">
                <div className="icon">👤</div>
                <div className="title">Your account is unverified</div>
                <div className="text">Your account can be linked to your friend's account if you play over the same Internet or device. This way, only one of you can activate the voucher.</div>
            </div>

            <div className="verification-limits">
                <div className="block-title">Advantages</div>
                <div className="limit"><div className="title">🎁 Personal activation of the voucher</div></div>
                <div className="limit"><div className="title">👨‍💻 Priority support</div></div>
                <div className="limit">
                    <div className="title">💰 Cashouts limit</div>
                    <div className="value">$5,000 / day</div>
                </div>
            </div>

            <div className="verification-buttons">
                <div className="button green" onClick={onClick} style={{
                    opacity: button ? 0.7 : 1,
                    cursor: button ? "no-drop" : "pointer"
                }}>{!button ? 'Verify my identity' : 'Please wait..'}</div>
                <div className="button" onClick={onCancel}>Verify later</div>
            </div>
        </div>  
    )
}